import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { NOTICE_DETAIL_URL} from '../../utils/urls';
import instance from "../../services/services";
import { useLanguage } from "../../hooks/useLanguage";

function NoticeDetail(){
  const { t } = useLanguage();
  const navigate = useNavigate();
  const { b_seq } = useParams();
  const [detailData, setDetailData] = useState(null);
  const [file, setFile] = useState([]);

  
  useEffect(() => {
    const fetchNoticeDetail = async () => {
      try {
        const response = await instance.post(NOTICE_DETAIL_URL, {
          "b_seq": b_seq
        });
        setFile(response.data.data.files);
        setDetailData(response.data.data.data); 
      } catch (error) {
        console.error("Failed to fetch notice detail:", error);
      }
    };

    fetchNoticeDetail();
  }, [b_seq]);

  // 목록 버튼 클릭 핸들러
  const handleBackToList = () => {
    navigate('/community');
  };
  
  const handleFileDownload = (fileUrl, fileName, isImage = false) => {
    if (isImage) {
      // 이미지는 새창으로 70% 크기로 열기
      const screenWidth = window.screen.width;
      const screenHeight = window.screen.height;
      const windowWidth = Math.round(screenWidth * 0.7);
      const windowHeight = Math.round(screenHeight * 0.7);
      const left = Math.round((screenWidth - windowWidth) / 2);
      const top = Math.round((screenHeight - windowHeight) / 2);
      
      const windowFeatures = `width=${windowWidth},height=${windowHeight},left=${left},top=${top},scrollbars=yes,resizable=yes`;
      
      window.open(fileUrl, '_blank', windowFeatures);
    } else {
      // 파일은 바로 다운로드
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  
  return(
    <div className="board_container">
      <h3 className="commu_title">{t("notice")}</h3>
        <ul className="board_list form_board">
          <li className="board_item">
            <div className="board_box flex-4 column">
                <h6 className="title flex-center-4 b1-2">
                  <span>{detailData?.subject}</span>
                </h6>
                <div className="board_info board_line">
                  <span className="text_small g-70">{detailData?.regist_date.substring(0, 16)}</span>
                </div>
              </div>
          </li>
        </ul>
        <div className="board_contents unset_box">
          <div dangerouslySetInnerHTML={{ __html: detailData?.contents }}></div>

        </div>
        {file.length > 0 && (
                <div className="clip_box">
                {file.map((file, index) => (
                  file.image_flag === 'Y' ? (
                    <div key={index} className="image_preview">
                      <img 
                        src={file.new_filepath} 
                        alt={file.org_filename}
                        style={{ maxWidth: '100px', height: '100px', cursor: 'pointer' }}
                        onClick={() => handleFileDownload(file.new_filepath, file.org_filename, true)}
                      />
                    </div>
                  ) : (
                    <button
                      key={index}
                      type="button"
                      className="clip_btn text_underline"
                      onClick={() => handleFileDownload(file.new_filepath, file.org_filename)}
                    >
                      <i className="clip"/>
                      {file?.org_filename}
                    </button>
                  )
                ))}
              </div>
        )}


      {/* 목록 버튼 */}
      <div className="submit_box mt_32">
        <button
          className="default_btn white lg"
          onClick={handleBackToList}
        >
          {t("list_0617")}
        </button>
      </div>
    </div>
  )
};

export default NoticeDetail;